var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { SideImageLayout, StandardLayout } from 'hx-ui';
import { useSyncFormWithStore } from 'hx-wizard';
import { FormProvider, useForm } from 'react-hook-form';
import { widgetActions } from '@/store';
import { UserDetailsForm } from '@/components/user-details/user-details-form.component';
import { FormNavigationButton, NavigationButtonsContainer, } from '@/components/navigation-button.component';
import { cn } from 'hx-util';
import { useSetProgress } from 'hx-progress';
import { useSelector } from 'react-redux';
import { StyledProgress } from '@/components/styled-progress.component';
import { useAnalytics } from 'hx-analytics';
import { sendScrollIntoView } from '@/helpers/send-scroll-into-view.helper';
import { useTestCompletionCallback } from '@/hooks/use-test-completion-callback.hook';
import { getCategoryPath } from 'hx-util';
export function DetailsFormPage() {
    var handleTestCompletion = useTestCompletionCallback();
    var navigate = useNavigate();
    useSetProgress(2, 1);
    var category = useSelector(function (state) { return state.dinTest.result.category; });
    var sendButtonClick = useAnalytics().sendButtonClick;
    var form = useForm({
        mode: 'all',
    });
    useSyncFormWithStore(form, ['widget', 'userDetails'], widgetActions.setUserDetails);
    var isFormTouched = Object.values(form.formState.touchedFields).some(Boolean);
    var onSubmit = form.handleSubmit(function (values) {
        sendScrollIntoView();
        sendButtonClick('test_result');
        handleTestCompletion();
        navigate("/result-category/".concat(getCategoryPath(category)));
        window.parent.postMessage({
            type: 'lx_analytics',
            event: {
                action: 'hd-lead',
                event_category: 'forms',
                event_label: 'form-eargo-widget',
                event_email: values['email'],
            },
        }, '*');
    });
    return (_jsx(SideImageLayout, { className: 'overflow-y-auto', leftPanelWidth: "40%", header: _jsx(StyledProgress, { className: "px-4 md:px-12 py-6", textClassName: 'font-bold' }), headingComponent: _jsx(Typography, __assign({ align: 'center', className: 'text-white text-2xl inline-block px-8' }, { children: _jsx("strong", { children: "Enter your contact details to get your results" }) })), content: _jsx(FormProvider, __assign({}, form, { children: _jsx("form", __assign({ onSubmit: onSubmit }, { children: _jsx(StandardLayout, { className: "md:max-h-[553px] md:overflow-y-auto pb-6 md:px-6", content: _jsxs("div", __assign({ className: "flex flex-col gap-6 p-4 md:p-0" }, { children: [_jsx("div", __assign({ className: "flex flex-col items-center gap-6 md:gap-4 md:sticky md:top-0 md:w-full md:bg-white md:z-10" }, { children: _jsx(Typography, __assign({ className: "text-3xl md:text-4xl font-extrabold text-balance max-w-[55rem]" }, { children: "Enter your contact details to receive your results, educational content, and exclusive offers." })) })), _jsx(UserDetailsForm, { form: form })] })), nav: _jsx(NavigationButtonsContainer, __assign({ className: "px-6 w-full md:w-auto" }, { children: _jsx(FormNavigationButton, { type: "submit", label: "View my results", className: cn('mx-auto max-w-fit px-10 disabled:bg-eargo-sinopia/40 disabled:text-white disabled:border-none', {
                                'bg-white border-eargo-sinopia border-solid border text-eargo-sinopia': !isFormTouched,
                            }) }) })) }) })) })) }));
}
